import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import { Link } from "react-router-dom";

// img
import u1 from "../../../../Assets/images/user.png";
import { useDispatch, useSelector } from "react-redux";
import { getAgencies } from "../../../../store/agency/actions";
import Table from "../../../../components/Common/Table";
import { APPROVING_AGENCY } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import CustomPagination from "../../../../components/Common/CustomPagination";
import Search from "../../../../components/Common/Search";
import { exportCsvHandler } from "../../../../utilities/utilies";
import TableProfile from "../../../../components/Common/TableProfile";
import StatusFilter from "../../../../components/Common/StatusFilter";
import { statusFilterOptionArr } from "../../../../utilities/const";
import PaginationFilter from "../../../../components/Common/PaginationFilter";

const NewAgencyRequest = () => {
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });

  const dispatch = useDispatch();

  const agenciesData = useSelector((s) => s.agency.agencyListData);
  console.log(getAgencies , "getAgencies21321321123213");
  const agenciesDataTotal = useSelector((s) => s.agency.total);
  const loader = useSelector((s) => s.agency.loading);

  const pageChangeHandler = (page) => {
    const newbody = {
      ...body,
      page,
    };
    setBody((p) => ({
      ...p,
      page,
    }));
    dispatch(getAgencies(newbody, "new_request"));
  };

  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody(newbody);
    if (body.search.trim() === "")
      dispatch(getAgencies(newbody, "new_request"));
  }, [body.search]);

  useEffect(() => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody(newbody);
    dispatch(getAgencies(newbody, "new_request"));
  }, [body.status, body.limit]);

  const approveAgencyHandler = async (item, status) => {
    try {
      const res = await APPROVING_AGENCY({ providerId: item._id, status }); 
      if (res.data.status === "success") {
        toast.success(res.data.message);
        dispatch(getAgencies(body, "new_request"));
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const searchHandler = (e) => {
    const newbody = {
      ...body,
      page: 1,
    };
    setBody((p) => ({
      ...p,
      page: 1,
    }));
    dispatch(getAgencies(newbody, "new_request"));
  };

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "Business Name",
      isComponent: true,
      component: (item, arr) => (
        <TableProfile imageSrc={item.profileImage} name={item.name} />
      ),
    },
    {
      label: "Type",
      id: "type",
      classNames: "fw-sbold",
    },
    {
      label: "Email",
      id: "email",
      classNames: "fw-sbold",
    },

    {
      label: "Phone Number",
      id: "",
      isComponent: true,
      component: (item) => (
        <p className={` m-0 fw-sbold`}>
          {item?.countryCode + " " + item?.mobileNumber}
        </p>
      ),
    },

    // {
    //   label: "Request",
    //   id: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn gap-10 d-flex align-items-center ">
    //       {/* {item.status == "created" ? (
    //         <>
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="33"
    //             height="33"
    //             viewBox="0 0 33 33"
    //             fill="none"
    //           >
    //             <circle cx="16.5" cy="16.5" r="16.5" fill="#D9D9D9" />
    //             <path
    //               d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
    //               fill="white"
    //             />
    //             <path
    //               d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
    //               fill="white"
    //             />
    //           </svg>
    //         </>
    //       ) : (
    //         <>
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="33"
    //             height="33"
    //             viewBox="0 0 33 33"
    //             fill="none"
    //           >
    //             <circle cx="16.5" cy="16.5" r="16.5" fill="#C11111" />
    //             <path
    //               d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
    //               fill="white"
    //             />
    //             <path
    //               d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
    //               fill="white"
    //             />
    //           </svg>
    //         </>
    //       )} */}
    //       {/* {item.request == "approve" ? ( */}
    //       <>
    //         <svg
    //           onClick={() => approveAgencyHandler(item, "rejected")}
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="33"
    //           height="33"
    //           viewBox="0 0 33 33"
    //           fill="none"
    //           style={{ cursor: "pointer" }}
    //         >
    //           <circle cx="16.5" cy="16.5" r="16.5" fill="#C11111" />
    //           <path
    //             d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
    //             fill="white"
    //           />
    //           <path
    //             d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
    //             fill="white"
    //           />
    //         </svg>
    //       </>
    //       {/* ) : ( */}
    //       <>
    //         <svg
    //           onClick={() => approveAgencyHandler(item, "approved")}
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="33"
    //           height="33"
    //           viewBox="0 0 33 33"
    //           fill="none"
    //           style={{ cursor: "pointer" }}
    //         >
    //           <circle cx="16.5" cy="16.5" r="16.5" fill="#D9D9D9" />
    //           <path
    //             d="M24.4699 11.2886C23.7596 10.5783 22.6097 10.5783 21.8994 11.2886L13.2104 19.9776L10.1019 16.8691C9.39159 16.1588 8.23821 16.1588 7.53142 16.8691C6.82462 17.5794 6.8211 18.7328 7.53142 19.4396L11.9269 23.8351C12.6372 24.5454 13.7871 24.5454 14.4974 23.8351L24.4699 13.8591C25.1767 13.1488 25.1767 11.9989 24.4699 11.2886Z"
    //             fill="white"
    //           />
    //         </svg>
    //       </>
    //       {/* )} */}
    //     </div>
    //   ),
    // },
    {
      label: "View",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Link
            to={`/manage-agency/agency-request/view/${item._id}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 25 17"
              fill="none"
            >
              <path
                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                fill="#666666"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      <section className="Agency py-2 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter gap-10 mb-3 d-flex align-itmes-center justify-content-between flex-wrap">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-itmes-center gap-10">
                    {/* <StatusFilter
                      body={body}
                      setBody={setBody}
                      statusFilterOptionArr={statusFilterOptionArr}
                    /> */}
                    <PaginationFilter setBody={setBody} body={body} />
                    <li className="">
                      <Search setBody={setBody} searchHandler={searchHandler} />
                    </li>
                  </ul>
                </div>
                <div className="right">
                  <div className="btnWrpper d-flex align-items-center gap-10">
                    {/* <Button className="d-inline-flex align-items-center justify-content-center commonBtn GreyBtn">
                      Import CSV
                    </Button> */}
                    {/* <Button
                      className="d-inline-flex align-items-center justify-content-center commonBtn"
                      type="button"
                      onClick={() => exportCsvHandler("agencies")}
                    >
                      Export CSV
                    </Button> */}
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table data={agenciesData} column={col} loader={loader} />
                <div className="d-flex justify-content-end">
                  <CustomPagination
                    total={agenciesDataTotal}
                    current={body.page}
                    pageSize={body.limit}
                    pageChangeHandler={pageChangeHandler}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default NewAgencyRequest;
